import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ApiPage from './app/API/ApiPage';
import ApiAccessTokenPage from './app/APIAccessToken/ApiAccessTokenPage';
import AdminInfoPage from './app/Admins/AdminInfo/AdminInfoPage';
import AdminsListPage from './app/Admins/AdminList/AdminsListPage';
import AgencyInfoPage from './app/Agency/Info/AgencyInfoPage';
import AgencyListPage from './app/Agency/List/AgencyListPage';
import ForgottenPage from './app/AuthControl/Forgotten/ForgottenPage';
import LoginPage from './app/AuthControl/Login/LoginPage';
import InvoiceInfoPage from './app/Billing/Invoice/InvoiceInfo/InvoiceInfoPage';
import InvoiceListPage from './app/Billing/Invoice/InvoiceList/InvoiceListPage';
import UnauthorizedListPage from './app/Billing/Invoice/Unauthorized/UnauthorizedListPage';
import QuotationListPage from './app/Billing/Quotation/List/QuotationListPage';
import TransactionsPage from './app/Billing/Transactions/TransactionsPage';
import CustomersDetailsPage from './app/Customer/CustomerDetails/CustomerDetailsPage';
import DashboardPage from './app/Dashboard/DashboardPage';
import DocumentationPage from './app/Documentation/DocumentationPage';
import GitPage from './app/Git/GitPage';
import GitRepositoryListPage from './app/Git/GitRepositoryListPage';
import ExternalLogListPage from './app/Logs/ExternalList/ExternalLogListPage';
import LogFilesListPage from './app/Logs/FilesList/LogFilesListPage';
import UserProfilePage from './app/Profile/UserProfilePage';
import ForecastReportPage from './app/Reports/ForecastReport/ForecastReportPage';
import OtherReportPage from './app/Reports/OtherReport/OtherReportPage';
import ReportInfoPage from './app/Reports/ReportInfoPage';
import SaleReportPage from './app/Reports/SaleReport/SaleReportPage';
import SecurityPage from './app/Security/SecurityPage';
import ServicesManagePage from './app/Services/Manage/ServicesManagePage';
import ServicePendingPage from './app/Services/Pending/ServicePendingPage';
import ServiceInfoPage from './app/Services/ServiceInfo/ServiceInfoPage';
import AuthManagePage from './app/Settings/AuthManage/AuthManagePage';
import BasicSettingPage from './app/Settings/Basic/BasicSettingPage';
import InvoiceConfigPage from './app/Settings/Invoice/InvoiceConfigPage';
import ProductDetailsPage from './app/Settings/ProductList/ProductDetails/ProductDetailsPage';
import ProductListPage from './app/Settings/ProductList/ProductListPage';
import ServiceDetailsPage from './app/Settings/Services/ServiceDetails/ServiceDetailsPage';
import ServicesPage from './app/Settings/Services/ServicesPage';
import StaticDataPage from './app/Settings/StaticData/StaticDataPage';
import SubscriptionsDetailsPage from './app/Subscriptions/SubscriptionsDetails/SubscriptionsDetailsPage';
import SubscriptionsPage from './app/Subscriptions/SubscriptionsPage';
import SubscriptionPendingPage from './app/Subscriptions/SubscriptionsPending/SubscriptionPendingPage';
import SupportTicketInfoPage from './app/SupportTicket/SupportTicketInfo/SupportTicketInfoPage';
import SupportTicketPage from './app/SupportTicket/SupportTicketPage';
import Menus from './features/Menus/Menus';
import NotFound from './features/NotFound/NotFoundPage';

function RouteHandler() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                {/* Add 404 page */}
                <Route path="*" element={<NotFound />} />

                <Route path="/git" element={<GitPage />} />
                <Route path="/git-ripo-list" element={<GitRepositoryListPage />} />

                {/* Public Pages */}
                <Route path="/login" element={<LoginPage />} />
                {/* <Route path="/registration" element={<RegistrationPage />} /> */}
                <Route path="/forgot-password" element={<ForgottenPage />} />

                <Route path="/reports/:category/:type" element={<ReportInfoPage />} />

                {/* Private Pages */}
                <Route path="/" element={<Menus />}>
                    <Route path="/profile" element={<UserProfilePage />} />
                    <Route path="/security" element={<SecurityPage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />

                    {/* Admin Pages */}
                    <Route path="/settings/admins" element={<AdminsListPage />} />
                    <Route path="/settings/admins/:userID/info/" element={<AdminInfoPage />} />

                    <Route path="/agency" element={<AgencyListPage />} />
                    <Route path="/agency/:agencyId/info" element={<AgencyInfoPage />} />
                    <Route path="/agency/:agencyId/:tab" element={<AgencyInfoPage />} />

                    <Route
                        path="/agency/:agencyId/:tab/:userID/info"
                        element={<CustomersDetailsPage />}
                    />

                    {/* Customer Pages */}
                    {/* <Route path="/customers" element={<CustomerPage />} />
                    <Route path="/customers/:userID/info/" element={<CustomersDetailsPage />} /> */}

                    {/* Subscription Pages */}
                    <Route path="/subscriptions/manage" element={<SubscriptionsPage />} />
                    <Route path="/subscriptions/pending" element={<SubscriptionPendingPage />} />
                    <Route
                        path="/subscriptions/manage/:id/info"
                        element={<SubscriptionsDetailsPage />}
                    />

                    {/* Service Page */}
                    <Route path="/services/manage" element={<ServicesManagePage />} />
                    <Route path="/services/manage/:id/info" element={<ServiceInfoPage />} />
                    <Route path="/services/pending" element={<ServicePendingPage />} />
                    {/* Logs Pages */}
                    <Route path="/logs/files" element={<LogFilesListPage />} />
                    <Route path="/logs/external" element={<ExternalLogListPage />} />

                    <Route path="/reports/sales" element={<SaleReportPage />} />
                    <Route path="/reports/forecast" element={<ForecastReportPage />} />
                    <Route path="/reports/other" element={<OtherReportPage />} />
                    <Route path="/api/list" element={<ApiPage />} />
                    <Route path="/api/access-token" element={<ApiAccessTokenPage />} />

                    {/* Setting Pages */}
                    <Route path="/settings/basic" element={<BasicSettingPage />} />
                    <Route path="/settings/static" element={<StaticDataPage />} />

                    <Route path="/settings/products" element={<ProductListPage />} />
                    <Route
                        path="/settings/products/:productId/info"
                        element={<ProductDetailsPage />}
                    />

                    <Route path="/settings/invoice" element={<InvoiceConfigPage />} />
                    <Route path="/settings/services" element={<ServicesPage />} />
                    <Route
                        path="/settings/services/:serviceId/info"
                        element={<ServiceDetailsPage />}
                    />
                    <Route path="/settings/auth-manage" element={<AuthManagePage />} />
                    <Route path="/documentation" element={<DocumentationPage />} />

                    {/* Billing Pages */}
                    <Route path="/billing/transactions" element={<TransactionsPage />} />
                    <Route path="/billing/invoices" element={<InvoiceListPage />} />
                    <Route path="/billing/unauthorized" element={<UnauthorizedListPage />} />
                    <Route path="/billing/quotations" element={<QuotationListPage />} />
                    <Route path="/billing/invoices/:invoiceId/info" element={<InvoiceInfoPage />} />

                    {/* Support Ticket */}
                    <Route path="/support-ticket" element={<SupportTicketPage />} />
                    <Route path="/support-ticket/:id/info" element={<SupportTicketInfoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
export default RouteHandler;
